import { useContext } from 'react'
import { WorkoutTemplateBuilderContext } from '../../WorkoutTemplateBuilder'
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/solid'

import PlusMinusButtonChanger from 'components/WorkoutTemplateBuilder/Components/PlusMinusButtonChanger'

export default function ExerciseSetUnitsButton({ phaseIndex, exercise, exerciseIndex }) {
    const { mode, mutateExercise, previousWeekWorkoutTemplateJSON } = useContext(WorkoutTemplateBuilderContext)

    // If exercise reps vary all we need to return is the varying text
    if (!exercise.uniformReps) {
        // For rep set unit
        if (exercise.setUnit === 'reps') {
            return <div className="h-8 text-xs flex justify-center items-center border-l border-stone-400 ">Reps: Vary</div>
        }

        // For seconds set unit
        if (exercise.setUnit === 'seconds') {
            return <div className="h-8 text-xs flex justify-center items-center  border-l border-stone-400 ">Time: Vary</div>
        }
    }

    // If exercise reps are uniform check the different cases
    if (exercise.uniformReps) {
        switch (mode) {
            // Edit Mode
            case 'edit':
                // For reps set unit
                if (exercise.setUnit === 'reps') {
                    return (
                        <div className="h-8 flex text-xs justify-center items-center border-x px-2 border-stone-400 ">
                            <PlusMinusButtonChanger
                                label="Reps:"
                                value={exercise.sets[0].reps} // Show to first set reps
                                lateral={exercise.lateral}
                                handleAddFunction={() => mutateExercise('uniform-add-rep', phaseIndex, exerciseIndex)}
                                handleSubtractFunction={() => mutateExercise('uniform-subtract-rep', phaseIndex, exerciseIndex)}
                            />
                        </div>
                    )
                }

                // For seconds set unit
                if (exercise.setUnit === 'seconds') {
                    return (
                        <div className="h-8 flex text-xs justify-center items-center border-x px-2 border-stone-400 ">
                            <PlusMinusButtonChanger
                                label="Time:"
                                value={exercise.sets[0].seconds} // Show to first set seconds
                                lateral={exercise.lateral}
                                setUnit={exercise.setUnit}
                                handleAddFunction={() => mutateExercise('uniform-add-seconds', phaseIndex, exerciseIndex)}
                                handleSubtractFunction={() => mutateExercise('uniform-subtract-seconds', phaseIndex, exerciseIndex)}
                            />
                        </div>
                    )
                }

                break

            // View Mode
            case 'view':
                // For rep set unit
                if (exercise.setUnit === 'reps') {
                    return (
                        <div className="h-8 pl-4 text-xs flex justify-center items-center border-l border-stone-400">
                            {exercise.sets[0].reps} {exercise.lateral === 'unilateral' ? ' / s' : ''}
                            {/* Week over week rep changes */}
                            {previousWeekWorkoutTemplateJSON !== null && exercise.sets[0].reps !== previousWeekWorkoutTemplateJSON.phases[phaseIndex].exercises[exerciseIndex].sets[0].reps && (
                                <div className="flex items-center gap-x-1 bg-orange-400 ml-1 px-2 text-white font-bold rounded-md">
                                    {exercise.sets[0].reps - previousWeekWorkoutTemplateJSON.phases[phaseIndex].exercises[exerciseIndex].sets[0].reps > 0 && (
                                        <ChevronUpIcon className="text-white h-3" />
                                    )}

                                    {exercise.sets[0].reps - previousWeekWorkoutTemplateJSON.phases[phaseIndex].exercises[exerciseIndex].sets[0].reps < 0 && (
                                        <ChevronDownIcon className="text-white h-3" />
                                    )}

                                    {Math.abs(exercise.sets[0].reps - previousWeekWorkoutTemplateJSON.phases[phaseIndex].exercises[exerciseIndex].sets[0].reps)}
                                </div>
                            )}
                        </div>
                    )
                }

                // For seconds set unit
                if (exercise.setUnit === 'seconds') {
                    return (
                        <div className="h-8 pl-4 text-xs flex justify-center items-center border-l border-stone-400">
                            {exercise.sets[0].seconds}s {exercise.lateral === 'unilateral' ? ' / s' : ''}
                        </div>
                    )
                }

                break

            // Error Message
            default:
                console.error('[' + mode + '] is not a valid mode!!')
        }
    }
}
